import React, { Component } from 'react';
import FileUploaderBlob from './../../../commons/FileUploaderBlob.js';
import DownloadFile from './../../../commons/DownloadFile.js';

export default class VehicleMapping extends Component {
	render(){
		return(
			<div className="dump-ingestion-wrapper">
				<div className="white-box">
					<div className="page-header-title">
						Vehicle Mapping
					</div>
					<div>
						<DownloadFile title="Vehicle Mapping Header" url="dump/vehicle-mapping/header"/>
					</div>
					<div className="top-thirty">
						<FileUploaderBlob url="ingest/dispatch/vehicle-mapping"/>
					</div>
				</div>
			</div>);
	}
}


// WEBPACK FOOTER //
// ./src/screens/DispatchJobs/Components/VehicleMapping.js